<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">{{ data.title }}</h3>
  </header>

  <section
    class="check-cases"
    [class.border]="data.main.isApplicable"
    [attr.id]="data.main.title"
  >
    <mat-slide-toggle
      [color]="data.main.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.main.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="data.main.isApplicable && !data.main.isPassed"
        >{{ data.main.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.main.isApplicable && !data.main.isPassed"
      *ngIf="readonly || printPreview"
    >
      {{ data.main.title }}
    </span>
    <div class="cases" *ngIf="data.main.isApplicable; else notApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.isSafetyPlansSubmitted"
        [fieldSection]="data.main.title"
      ></authority-labs-check-case>
      <authority-labs-check-risk-levels-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.structureRisks"
        [fieldSection]="data.main.title"
      ></authority-labs-check-risk-levels-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.waterSupplyDescription"
        [fieldSection]="data.main.title"
      ></authority-labs-check-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.cityWaterSupplyCharacteristics"
        [fieldSection]="data.main.title"
        [characteristics]="cityWaterSupplyCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.plumberRoomWaterSupplyCharacteristics"
        [fieldSection]="data.main.title"
        [characteristics]="plumberRoomWaterSupplyCharacteristics"
      ></authority-labs-check-water-characteristics-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.closedWaterSprinklerSystems.isApplicable"
    [attr.id]="data.closedWaterSprinklerSystems.title"
  >
    <mat-slide-toggle
      [color]="data.closedWaterSprinklerSystems.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.closedWaterSprinklerSystems.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.closedWaterSprinklerSystems.isApplicable &&
          !data.closedWaterSprinklerSystems.isPassed
        "
        >{{ data.closedWaterSprinklerSystems.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.closedWaterSprinklerSystems.isApplicable &&
        !data.closedWaterSprinklerSystems.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.closedWaterSprinklerSystems.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.closedWaterSprinklerSystems.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.closedWaterSprinklerSystems.deploymentAccordingSpec"
        [fieldSection]="data.closedWaterSprinklerSystems.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.closedWaterSprinklerSystems.designedPipeType"
        [fieldSection]="data.closedWaterSprinklerSystems.title"
      ></authority-labs-check-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.closedWaterSprinklerSystems.maxWaterNeededAtMainStation
        "
        [fieldSection]="data.closedWaterSprinklerSystems.title"
        [characteristics]="maxWaterCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.closedWaterSprinklerSystems.maxWaterNeededAtSource"
        [fieldSection]="data.closedWaterSprinklerSystems.title"
        [characteristics]="maxWaterCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-time-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.closedWaterSprinklerSystems.sprinklerOffTimeRequirenments
        "
        [fieldSection]="data.closedWaterSprinklerSystems.title"
      ></authority-labs-check-time-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.closedWaterSprinklerSystems.requiredPoolingVolume"
        [fieldSection]="data.closedWaterSprinklerSystems.title"
        [characteristics]="poolingVolumeCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.closedWaterSprinklerSystems
            .hydraulicWaterRequirementMatchWaterSupplyDesign
        "
        [fieldSection]="data.closedWaterSprinklerSystems.title"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.waterFloodingSystems.isApplicable"
    [attr.id]="data.waterFloodingSystems.title"
  >
    <mat-slide-toggle
      [color]="data.waterFloodingSystems.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.waterFloodingSystems.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.waterFloodingSystems.isApplicable &&
          !data.waterFloodingSystems.isPassed
        "
      >
        {{ data.waterFloodingSystems.title }}
      </span>
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.waterFloodingSystems.isApplicable &&
        !data.waterFloodingSystems.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.waterFloodingSystems.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.waterFloodingSystems.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterFloodingSystems.deploymentAccordingSpec"
        [fieldSection]="data.waterFloodingSystems.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterFloodingSystems.pipingDesignType"
        [fieldSection]="data.waterFloodingSystems.title"
      ></authority-labs-check-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterFloodingSystems.maxWaterNeededAtMainStation"
        [fieldSection]="data.waterFloodingSystems.title"
        [characteristics]="maxWaterCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterFloodingSystems.maxWaterNeededAtSource"
        [fieldSection]="data.waterFloodingSystems.title"
        [characteristics]="maxWaterCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-time-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterFloodingSystems.sprinklerOffTimeRequirenments"
        [fieldSection]="data.waterFloodingSystems.title"
      ></authority-labs-check-time-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterFloodingSystems.requiredPoolingVolume"
        [fieldSection]="data.waterFloodingSystems.title"
        [characteristics]="poolingVolumeCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.waterFloodingSystems.floodingSystemOperationDescription
        "
        [fieldSection]="data.waterFloodingSystems.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.waterFloodingSystems
            .hydraulicWaterRequirementMatchWaterSupplyDesign
        "
        [fieldSection]="data.waterFloodingSystems.title"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.preactionSystems.isApplicable"
    [attr.id]="data.preactionSystems.title"
  >
    <mat-slide-toggle
      [color]="data.preactionSystems.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.preactionSystems.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.preactionSystems.isApplicable && !data.preactionSystems.isPassed
        "
        >{{ data.preactionSystems.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.preactionSystems.isApplicable && !data.preactionSystems.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.preactionSystems.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.preactionSystems.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.preactionSystems.deploymentAccordingSpec"
        [fieldSection]="data.preactionSystems.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.preactionSystems.pipingDesignType"
        [fieldSection]="data.preactionSystems.title"
      ></authority-labs-check-case>
      <authority-labs-check-preaction-system-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.preactionSystems.preactionSystemType"
        [fieldSection]="data.preactionSystems.title"
      ></authority-labs-check-preaction-system-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.preactionSystems.systemTopPipingVolumeAccordingSpec"
        [fieldSection]="data.preactionSystems.title"
      ></authority-labs-check-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.preactionSystems.maxWaterNeededAtMainStation"
        [fieldSection]="data.preactionSystems.title"
        [characteristics]="maxWaterCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.preactionSystems.maxWaterNeededAtSource"
        [fieldSection]="data.preactionSystems.title"
        [characteristics]="maxWaterCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-time-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.preactionSystems.sprinklerOffTimeRequirenments"
        [fieldSection]="data.preactionSystems.title"
      ></authority-labs-check-time-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.preactionSystems.requiredPoolingVolume"
        [fieldSection]="data.preactionSystems.title"
        [characteristics]="poolingVolumeCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.preactionSystems.hydraulicWaterRequirementMatchWaterSupplyDesign
        "
        [fieldSection]="data.preactionSystems.title"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.deploymentAgainstEarthquakes.isApplicable"
    [attr.id]="data.deploymentAgainstEarthquakes.title"
  >
    <mat-slide-toggle
      [color]="data.deploymentAgainstEarthquakes.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.deploymentAgainstEarthquakes.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.deploymentAgainstEarthquakes.isApplicable &&
          !data.deploymentAgainstEarthquakes.isPassed
        "
        >{{ data.deploymentAgainstEarthquakes.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.deploymentAgainstEarthquakes.isApplicable &&
        !data.deploymentAgainstEarthquakes.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.deploymentAgainstEarthquakes.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.deploymentAgainstEarthquakes.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.deploymentAgainstEarthquakes.deploymentAccordingSpec"
        [fieldSection]="data.deploymentAgainstEarthquakes.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.deploymentAgainstEarthquakes.pipingTypeAccordingSpec"
        [fieldSection]="data.deploymentAgainstEarthquakes.title"
      ></authority-labs-check-case>
      <authority-labs-check-z-coefficient-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.deploymentAgainstEarthquakes.zCoefficient"
        [fieldSection]="data.deploymentAgainstEarthquakes.title"
      ></authority-labs-check-z-coefficient-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.deploymentAgainstEarthquakes.calculationsAccordingSpec
        "
        [fieldSection]="data.deploymentAgainstEarthquakes.title"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.foamCenter.isApplicable"
    [attr.id]="data.foamCenter.title"
  >
    <mat-slide-toggle
      [color]="data.foamCenter.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.foamCenter.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.foamCenter.isApplicable && !data.foamCenter.isPassed
        "
        >{{ data.foamCenter.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.foamCenter.isApplicable && !data.foamCenter.isPassed"
      *ngIf="readonly || printPreview"
      >{{ data.foamCenter.title }}
    </span>
    <div class="cases" *ngIf="data.foamCenter.isApplicable; else notApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenter.foamCenterType"
        [fieldSection]="data.foamCenter.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenter.certificatesAndCatalogs"
        [fieldSection]="data.foamCenter.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenter.dosageUnitType"
        [fieldSection]="data.foamCenter.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenter.concentrateType"
        [fieldSection]="data.foamCenter.title"
      ></authority-labs-check-case>
      <authority-labs-check-capacity-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenter.concentratedContainerCapacity"
        [fieldSection]="data.foamCenter.title"
      ></authority-labs-check-capacity-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenter.foamCenterSchemeAccordingSpec"
        [fieldSection]="data.foamCenter.title"
      ></authority-labs-check-case>
    </div>
  </section>
</main>

<ng-template #notApplicable>
  <mat-radio-group disabled="true" class="print-preview" *ngIf="printPreview">
    <mat-radio-button checked="false">מתאים</mat-radio-button>
    <mat-radio-button checked="false">לא מתאים</mat-radio-button>
    <mat-radio-button value="true" checked="true">לא ישים</mat-radio-button>
  </mat-radio-group>
</ng-template>
